/**
 * Moved to `@sizzlenz/shared-frontend/api`.
 * Re-exported here so existing `@/lib/api/endpoints` imports keep working.
 */
export * from '@sizzlenz/shared-frontend/api';
